$(function() {
	$('.flash-system').each(function() {
		var $flash = $(this);
		$flash.append('<i class="flash-close fa fa-times"></i>').on('click', function() {
			$flash.addClass('flash-hidden');
		});
	});

	window.setTimeout(function() {
		$('.flash-system').addClass('flash-hidden');
	}, 20000);
});
